import axiosInstance from './config/api';

export type DeleteWorkflowPhoneNumbersParams = {
    workflowId: string;
    phoneNumberIds: string[];
};

export type AlsoDeletedPhoneNumberRow = {
    id: string;
    phoneNumber: string;
    workflowId: string | null;
};

export type DeleteWorkflowPhoneNumbersResult = {
    releasedNumbers: string[];
    failedToReleaseNumbers: string[];
    softDeletedRows: number;
    alsoDeletedRows: AlsoDeletedPhoneNumberRow[];
    livekitOutboundSynced: boolean;
    livekitInboundSynced: boolean;
    deletedInboundTrunks: string[];
    warnings?: string;
};

export const deleteWorkflowPhoneNumbers = async (params: DeleteWorkflowPhoneNumbersParams) => {
    const { data } = await axiosInstance.post<DeleteWorkflowPhoneNumbersResult>(
        '/telephony/workflow-phone-numbers/delete',
        params
    );
    return data;
};
